<!-- <div class="app-sidebar sidebar-shadow bg-vicious-stance header-text-light">
    <div class="app-header__logo">
        <div class="logo-src"></div>
        <div class="header__pane ml-auto">
            <div>
                <button type="button" class="hamburger close-sidebar-btn hamburger--elastic"
                    data-class="closed-sidebar">
                    <span class="hamburger-box">
                        <span class="hamburger-inner"></span>
                    </span>
                </button>
            </div>
        </div>
    </div>
    <div class="app-header__mobile-menu">
        <div>
            <button type="button" class="hamburger hamburger--elastic mobile-toggle-nav">
                <span class="hamburger-box">
                    <span class="hamburger-inner"></span>
                </span>
            </button>
        </div>
    </div>
    <div class="app-header__menu">
        <span>
            <button type="button" class="btn-icon btn-icon-only btn btn-primary btn-sm mobile-toggle-header-nav">
                <span class="btn-icon-wrapper">
                    <i class="fa fa-ellipsis-v fa-w-6"></i>
                </span>
            </button>
        </span>
    </div>
    <div class="scrollbar-sidebar">
        <div class="app-sidebar__inner">
            <ul class="vertical-nav-menu">
                <li class="app-sidebar__heading header-text-light text-white">
                    Dashboards
                </li>
                <li>
                    <a [routerLink]="['/']" routerLinkActive="mm-active" class="text-white"
                        [routerLinkActiveOptions]="{exact: true}">
                        <i><img src="../../../../assets/images/dboard.png" alt="" /></i>
                        Dashboard
                    </a>
                </li>
                <li class="app-sidebar__heading text-white">Plants</li>
                <li>
                    <a class="appSideBar" [routerLink]="['/plants']" routerLinkActive="mm-active"
                        (click)="showPlantList()">
                        <i><img src="../../../../assets/images/power/power-plant.png" alt="" /></i>
                        Plants
                    </a>
                </li>
                <li class="app-sidebar__heading text-white">Help Dask</li>
                <li>
                    <a class="appSideBar bottomArrow" routerLinkActive="mm-active">
                        <i><img src="../../../../assets/images/helpDesk.png" alt="" /></i>
                        Help Dask
                    </a>
                    <ul>
                       
                        <li>
                            <a [routerLink]="['/ticket-list']" routerLinkActive="mm-active" (click)="showPlantList()">
                                <i>•</i>
                                Ticket list
                            </a>
                        </li>
                        <li *ngIf="userType !== 'noc_user'  ">
                            <a [routerLink]="['/add-ticket']" routerLinkActive="mm-active" (click)="showPlantList()">
                                <i>•</i>
                                Add Ticket
                            </a>
                        </li>
                        <li *ngIf="userType === 'superuser'  ">
                            <a [routerLink]="['/priority']" routerLinkActive="mm-active" (click)="showPlantList()">
                                <i>•</i>
                                Priority
                            </a>
                        </li>
                        <li  *ngIf="userType === 'superuser'  "> 
                            <a [routerLink]="['/source']" routerLinkActive="mm-active" (click)="showPlantList()">
                                <i>•</i>
                                Source
                            </a>
                        </li>
                        <li  *ngIf="userType === 'superuser'  "> 
                            <a [routerLink]="['/category']" routerLinkActive="mm-active" (click)="showPlantList()">
                                <i>•</i>
                                Category
                            </a>
                        </li>
                        <li  *ngIf="userType === 'superuser'  "> 
                            <a [routerLink]="['/sub-category']" routerLinkActive="mm-active" (click)="showPlantList()">
                                <i>•</i>
                                Sub-Category
                            </a>
                        </li>
                    </ul>
                </li>
                <li class="app-sidebar__heading text-white"> </li>
                <li>
                    <a [routerLink]="['/alarm']" routerLinkActive="mm-active" class="text-white"
                        [routerLinkActiveOptions]="{exact: true}">
                         <i><img src="../../../../assets/images/alarm.png" alt="" /></i>

                         Alarm Center
                    </a>
                </li>
                <li *ngIf="userType === 'superuser' " class="app-sidebar__heading text-white">System Management</li>

                <li   *ngIf="userType === 'superuser' ">
                    <a class="appSideBar bottomArrow" routerLinkActive="mm-active">
                        <i><img src="../../../../assets/images/helpDesk.png" alt="" /></i>
                        User Management
                    </a>
                    <ul>
                        <li>
                            <a [routerLink]="['/user']" routerLinkActive="mm-active" (click)="showPlantList()">
                                <i>•</i>
                                All Users
                            </a>
                        </li>
                    </ul>
                </li>
            </ul>
        </div>
    </div>
</div> -->



<div id="app-menu-new" class="app-menu navbar-menu app-menu-new">
    <!-- LOGO -->
    <div class="navbar-brand-box">
        <!-- Dark Logo-->
        <!--
        <a href="index.html" class="logo logo-dark">
            <span class="logo-sm">
                <img src="assets/images/zerocarbon-logo-new.png" alt="" height="22">
            </span>
            <span>
                <img src="assets/images/logo.svg" alt="" width="172">
            </span>
        </a>
        -->
        <!-- Light Logo-->

        <a href="index.html" class="logo logo-light">
            <!-- New white-sidebar collapsed-state mark (see menu-sidebar-revamp.scss) -->
            <span class="sb-revamp-logo-sm">
                <img src="assets/img/logo-small.svg" alt="" height="28">
            </span>
            <span class="sb-revamp-logo-full">
                <img src="assets/img/logo.svg" alt="Punjab Group">
            </span>
        </a>
        <button type="button" class="btn btn-sm p-0 fs-20 header-item float-end btn-vertical-sm-hover"
            id="vertical-hover">
            <i class="ri-record-circle-line"></i>
        </button>
    </div>

    <div id="scrollbar">
        <div class="container-fluid">

            <div id="two-column-menu">
            </div>
            <ul class="navbar-nav" id="navbar-nav">
                <li class="menu-title"><span data-key="t-menu">Menu</span></li>
                <li class="menu-title"><span data-key="t-menu">Menu</span></li>

                <!-- Skeleton Loader -->
                <ng-container *ngIf="isLoadingMenu">
                    <li class="nav-item" *ngFor="let i of [1,2,3,4,5,6,7]">
                        <a class="nav-link menu-link placeholder-glow">
                            <span class="placeholder icon col-2 me-2"></span>
                            <span class="placeholder col-10"></span>
                        </a>
                    </li>
                </ng-container>
                <!-- Actual Menu Items -->
                <ng-container *ngIf="!isLoadingMenu">
                    <!-- Loop through main menu items -->
                    <ng-container *ngFor="let item of sideMenuItems">
                        <!-- Category items (with children) -->
                        <li class="nav-item sb-revamp-item"
                            *ngIf="item.is_category && item.children && item.children.length > 0">
                            <a class="nav-link menu-link" [attr.href]="'#sidebar' + item.id" data-bs-toggle="collapse"
                                role="button" [class.active]="isMenuItemActive(item)" aria-expanded="false"
                                [attr.aria-controls]="'sidebar' + item.id">
                                <i *ngIf="item.icon" [innerHTML]="item.icon"></i>
                                <span [attr.data-key]="'t-' + item.name">{{ item.displayName }}</span>
                            </a>

                            <!-- Collapsed-sidebar hover flyout (see menu-sidebar-revamp.scss) -->
                            <div class="sb-revamp-flyout">
                                <div class="sb-revamp-flyout__title">{{ item.displayName }}</div>
                                <a *ngFor="let child of item.children" [routerLink]="[child.url]"
                                    (click)="showPlantList()" class="sb-revamp-flyout__link"
                                    [class.active]="isChildActive(child)">
                                    {{ child.displayName }}
                                </a>
                            </div>

                            <div class="collapse menu-dropdown" [class.show]="isMenuItemActive(item)"
                                [attr.id]="'sidebar' + item.id">
                                <ul class="nav nav-sm flex-column">
                                    <li class="nav-item" *ngFor="let child of item.children">
                                        <a [routerLink]="[child.url]" (click)="showPlantList()" class="nav-link"
                                            [class.active]="isChildActive(child)" [attr.data-key]="'t-' + child.name">
                                            {{ child.displayName }}
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </li>

                        <!-- Single items (Dashboard - no children) -->
                        <li class="nav-item sb-revamp-item"
                            *ngIf="item.is_category && (!item.children || item.children.length === 0)">
                            <a class="nav-link menu-link" [routerLink]="[item.url]" role="button"
                                [class.active]="isMainMenuActive([item.url])" aria-expanded="false">
                                <i *ngIf="item.icon" [innerHTML]="item.icon"></i>
                                <span [attr.data-key]="'t-' + item.name">{{ item.displayName }}</span>
                            </a>

                            <!-- Collapsed-sidebar hover flyout -->
                            <div class="sb-revamp-flyout">
                                <div class="sb-revamp-flyout__title">{{ item.displayName }}</div>
                            </div>
                        </li>
                    </ng-container>
                </ng-container>
            </ul>
        </div>
        <!-- Sidebar -->
    </div>
</div>